import React from 'react';
import useConfig from '../hooks/useConfig';

export default function OperatorRegistration({ autoStart = false, attemptId, operator }) {
  const { config, loading, error } = useConfig();
  const autoStartedRef = React.useRef(false);
  const [registrationError, setRegistrationError] = React.useState(null);

  const handleRegistration = React.useCallback(async () => {
    if (!config) return;

    sessionStorage.setItem('operator', operator);
    if (attemptId) {
      sessionStorage.setItem('attemptId', attemptId);
    }

    const operatorEndpoints = {
      paddypower: config.paddypowerRegistrationUrl || 'http://media.paddypower.com/redirect.aspx?pid=xxxx&bid=7143&redirectURL=http%3A%2F%2Fregister.paddypower.com%2Faccount%2Fregistration%3Fprod%3D56%26returnURL%3Dhttps%3A%2F%2Fidentitysso.paddypower.com%2Fapi%2FproductToken%3Fproduct%3Dfoe%26redirectMethod%3DPOST%26url%3Dhttps%3A%2F%2Ftesting-operators-calls.funteron-dev.com%2FoperatorCallback',
      skybet: config.skybetRegistrationUrl || 'http://ads.skybet.com/redirect.aspx?pid=xxxx&bid=xxxx&redirectURL=http%3A%2F%2Fregister.skybet.com%2Faccount%2Fregistration%3Fprod%3D56%26returnURL%3Dhttps%3A%2F%2Fidentitysso.skybet.com%2Fapi%2FproductToken%3Fproduct%3Dfoe%26redirectMethod%3DPOST%26url%3Dhttps%3A%2F%2Ftesting-operators-calls.funteron-dev.com%2FoperatorCallback',
      betfair: config.betfairRegistrationUrl || 'http://ads.betfair.com/redirect.aspx?pid=xxxx&bid=10603&redirectURL=http%3A%2F%2Fregister.betfair.com%2Faccount%2Fregistration%3Fprod%3D56%26returnURL%3Dhttps%3A%2F%2Fidentitysso.betfair.com%2Fapi%2FproductToken%3Fproduct%3Dfoe%26redirectMethod%3DPOST%26url%3Dhttps%3A%2F%2Ftesting-operators-calls.funteron-dev.com%2FoperatorCallback',
    };

    const authUrl = operatorEndpoints[operator.toLowerCase()];
    if (!authUrl) {
      setRegistrationError('Unknown Operator, missing registration URL details');
      return;
    }
    window.location.href = authUrl;
  }, [config, operator, attemptId]);

  React.useEffect(() => {
    if (autoStart && config && !autoStartedRef.current) {
      autoStartedRef.current = true;
      handleRegistration();
    }
  }, [autoStart, config, handleRegistration]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <p className="text-white text-lg">Loading configuration...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="bg-red-800 text-white p-6 rounded-lg max-w-md">
          <h2 className="text-xl font-bold mb-2">Configuration Error</h2>
          <p>{error}</p>
          <p className="mt-2 text-sm text-red-200">
            Ensure your <code>.env.local</code> or <code>.env.development</code> file is configured.
          </p>
        </div>
      </div>
    );
  }

  if (registrationError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="bg-red-800 text-white p-6 rounded-lg max-w-md">
          <h2 className="text-xl font-bold mb-2">Registration Error</h2>
          <p>{registrationError}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
      <div
        role="status"
        aria-label="Redirecting to Operator registration"
        className="w-12 h-12 border-4 border-gray-600 border-t-green-500 rounded-full animate-spin"
      />
      <span className="sr-only">Redirecting to Operator registration...</span>
    </div>
  );
}
